import type { DefaultQueryError } from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { apiRoutes } from '../api-routes';
import {
  type FavoriteDriver,
  getListFavoriteDriversFn,
} from './get-list-favorite-driver-fn';

export const useGetListFavoriteDrivers = (
  opts?: UseQueryOptions<FavoriteDriver[], DefaultQueryError>
) =>
  useQuery<FavoriteDriver[], DefaultQueryError>({
    queryKey: [apiRoutes.user.listFavoriteDrivers],
    queryFn: () => getListFavoriteDriversFn(),
    ...opts,
  });
